module.exports = __webpack_public_path__ + "static/img/bg64.d1b1cdc7.png";